import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
    selector: '[numericOnly]',
    standalone: false
})
export class NumericOnlyDirective {

    constructor(private el: ElementRef) { }

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
        const allowedKeys = [
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'Home', 'End'
        ];

        if (allowedKeys.includes(event.key) || /^[0-9]$/.test(event.key)) {
            return;
        } else {
            event.preventDefault();
        }
    }

    @HostListener('input', ['$event']) onInput(event: Event): void {
        const inputElement = this.el.nativeElement as HTMLInputElement;
        const initialValue = inputElement.value;
        const newValue = initialValue.replace(/[^0-9]/g, '');
        if (initialValue !== newValue) {
            inputElement.value = newValue;
            inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
}